
import { searchFieldSeperated, validateMaxDate } from '@/modules/transport/otp/views/distributeManage/receiptCenter/search.js';
import { Message } from 'element-ui';
import dayjs from 'dayjs';
import _ from 'lodash';

const advanceStringToArray = (data, advanceList) => {
    advanceList.forEach(key => {
        if (data[key]) {
            data[`${key}List`] = data[key] ? data[key].split(',') : [];
        }
        delete data[key];
    });
};
/**
 * @description 格式化查询参数
 * @param {Object} data 查询参数
 */
const formatSearchData = (data) => {
    const params = _.cloneDeep(data);
    params.dispatchNoList = searchFieldSeperated(data.dispatchNo || '');
    params.thawingDateStart = params.thawingDate ? dayjs(params.thawingDate[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.thawingDateEnd = params.thawingDate ? dayjs(params.thawingDate[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.createTimeStart = params.createTime ? dayjs(params.createTime[0]).format('YYYY-MM-DD HH:mm:ss') : '';
    params.createTimeEnd = params.createTime ? dayjs(params.createTime[1]).format('YYYY-MM-DD HH:mm:ss') : '';
    const advanceList = ['driver', 'driverContactWay'];
    advanceStringToArray(params, advanceList);
    if (params.driver) {
        params.driverList = params.driver.length ? params.driver.split(',') : [];
    }
    delete params.dispatchNo;
    delete params.thawingDate;
    delete params.createTime;

    return params;
};

const validateSearchData = (searchData) => {
    return validateMaxDate(searchData, 'thawingDateStart', 'thawingDateEnd', { span: 2, unit: 'month', noMessage: false }, '时间') &&
        validateMaxDate(searchData, 'createTimeStart', 'createTimeEnd', { span: 2, unit: 'month', noMessage: false }, '时间');
};

/**
 * @description 过滤对象中的空值（空字符串、空对象、空数组、null、undefined）
 * @param {Object} obj 待处理对象
 * @returns {Object} 处理后的真值对象
 */
const removeFalsyValues = obj => {
    return Object.fromEntries(
        Object.entries(obj).filter(([_, value]) =>
            (!(value === '' || value === null || value === undefined)) &&
            (!(Array.isArray(value) && value.length === 0)) &&
            (!(typeof value === 'object' && Object.keys(value).length === 0))
        )
    );
};

export { formatSearchData, validateSearchData, removeFalsyValues };